module.exports = __webpack_public_path__ + "img/7.1.faeb517d.jpg";